import { render, staticRenderFns } from "./ClientBatchSyncModal.vue?vue&type=template&id=2c1a83f7&scoped=true"
import script from "./ClientBatchSyncModal.vue?vue&type=script&lang=js"
export * from "./ClientBatchSyncModal.vue?vue&type=script&lang=js"
import style0 from "./ClientBatchSyncModal.vue?vue&type=style&index=0&id=2c1a83f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a83f7",
  null
  
)

export default component.exports